<template>
  <div class="human-verify" v-loading="loading" element-loading-text="加载中，请稍等...">
    <div v-if="loaded" class="verify-steps">
      <div class="step">
        <div class="step-num active">1</div>
        <div class="step-name">人像采集</div>
      </div>
      <div class="step">
        <div class="step-num" :class="{'active': portraitStep >= 2}">2</div>
        <div class="step-name">人证核验</div>
      </div>
      <div class="step">
        <div class="step-num" :class="{'active': portraitStep >= 3}">3</div>
        <div class="step-name">核对信息</div>
      </div>
    </div>
    <div v-if="loaded && portraitStep === 1" class="left-camera">
      <div class="camera-content">
        <div v-if="isFilming" class="camera-bg">
          <video ref="video" class="camera"></video>
          <canvas
            style="display: none"
            id="canvasCamera"
            ref="canvasDom"
          ></canvas>
        </div>
        <div v-else class="camera-img">
          <img v-if="cameraPhotoPath" :src="cameraPhotoPath" alt="">
          <div v-if="CameraPhotoCompareCode !== '0' && !isFilming" class="judge" :class="[CameraPhotoCompareCode === '2' ? 'red' : 'green']">
            <i v-if="CameraPhotoCompareCode === '2'" class="el-icon-close"></i>
            <i v-else-if="CameraPhotoCompareCode === '1'" class="el-icon-check"></i>
          </div>
          <span v-if="CameraPhotoCompareNum !== '' && CameraPhotoCompareNum != undefined && !isFilming" class="num">{{ (CameraPhotoCompareNum).toFixed(2) }}%</span>
        </div>
      </div>
      <div v-if="!isView" class="photo-group">
        <div v-if="!isFilming && !cameraPhotoPath" class="take-photo" @click="getCamera">拍摄</div>
        <div v-else-if="!isFilming && cameraPhotoPath" class="take-photo" @click="getCamera">重新拍照</div>
        <div v-if="!isFilming && cameraPhotoPath && CameraPhotoCompareCode === '2'" class="take-photo left" @click="humanFaceVerify">人工核验通过</div>
        <div v-if="isFilming" class="take-photo" @click="CloseCamera">关闭摄像头</div>
        <div v-if="isFilming" class="take-photo left" @click="takePhoto">拍照</div>
      </div>
      <div v-if="!isView" class="next-button">
        <div class="next" @click="toStepTwo">下一步</div>
      </div>
    </div>
    <div v-if="portraitStep === 2" class="right-info">
      <div class="top-diff">
        <div class="diff-content">
          <div class="id-img">
            <img :src="cameraPhotoPath" alt="">
            <div class="img-name">采集照片</div>
          </div>
          <div class="judge-outer">
            <div v-if="CameraPhotoCompareCode !== '0'"  class="judge" :class="[CameraPhotoCompareCode === '2' ? 'red' : 'green']">
              <i v-if="CameraPhotoCompareCode === '2'" class="el-icon-close"></i>
              <i v-else-if="CameraPhotoCompareCode === '1'" class="el-icon-check"></i>
            </div>
            <div v-if="CameraPhotoCompareNum" class="num">{{ (CameraPhotoCompareNum).toFixed(2) }}%</div>
          </div>
          <div class="id-img">
            <img :src="getPhotoBase64(userData.photobase64)" alt="">
            <div class="img-name">身份证照片</div>
          </div>
          <div class="judge-outer">
            <div v-if="userPhotoCompareCode !== '0'" class="judge" :class="[userPhotoCompareCode === '2' ? 'red' : 'green']">
              <i v-if="userPhotoCompareCode === '2'" class="el-icon-close"></i>
              <i v-else-if="userPhotoCompareCode === '1'" class="el-icon-check"></i>
            </div>
            <div v-if="userPhotoCompareNum" class="num">{{ (userPhotoCompareNum).toFixed(2) }}%</div>
          </div>
          <div class="self-img">
            <img :src="cardVerifyInfo.userPhotoPath" alt="">
            <div class="img-name">个人照片</div>
            <div @click="replaceUserPhoto" class="replace">替换为采集照片</div>
          </div>
        </div>
      </div>
      <div v-if="!isView" class="next-button">
        <div class="prev" @click="portraitStep = 1">上一步</div>
        <div class="next" @click="toStepThree">下一步</div>
      </div>
    </div>
    <div v-if="portraitStep === 3" class="three-step">
      <div class="bottom-check">
        <div class="check-content">
          <div class="basic-info">
            <div class="line">
              <div class="line-name">姓名</div>
              <div class="line-value">{{userData.name}}</div>
            </div>
            <div class="line">
              <div class="line-name">性别</div>
              <div class="line-value">{{userData.sex}}</div>
            </div>
            <div class="line">
              <div class="line-name">出生年月</div>
              <div class="line-value">{{DateFormat(userData.born)}}</div>
            </div>
            <div class="line">
              <div class="line-name">民族</div>
              <div class="line-value">{{userData.nation}}族</div>
            </div>
          </div>
          <div class="write-info">
            <div class="line">
              <div class="line-cell">
                <div class="line-cell-name">姓名</div>
                <div class="line-cell-value"><el-input v-model="cardVerifyInfo.trueName" placeholder="请输入姓名"></el-input></div>
              </div>
              <div class="is-pass">
                <i v-if="!checkIsPass(userData.name, cardVerifyInfo.trueName)" class="el-icon-close"></i>
                <i v-else class="el-icon-check"></i>
              </div>
            </div>
            <div class="line">
              <div class="line-cell">
                <div class="line-cell-name">性别</div>
                <div class="line-cell-value"><el-input v-model="cardVerifyInfo.gender" placeholder="请输入性别"></el-input></div>
              </div>
              <div class="is-pass">
                <i v-if="!checkIsPass(userData.sex, cardVerifyInfo.gender)" class="el-icon-close"></i>
                <i v-else class="el-icon-check"></i>
              </div>
            </div>
            <div class="line">
              <div class="line-cell">
                <div class="line-cell-name">出生年月</div>
                <div class="line-cell-value">
                  <el-date-picker
                    v-model="cardVerifyInfo.birthday"
                    format="yyyy年MM月dd日"
                    value-format="yyyy-MM-dd"
                    :clearable="false"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker>
                </div>
              </div>
              <div class="is-pass">
                <i v-if="!checkDateIsPass(userData.born, cardVerifyInfo.birthday)" class="el-icon-close"></i>
                <i v-else class="el-icon-check"></i>
              </div>
            </div>
            <div class="line">
              <div class="line-cell">
                <div class="line-cell-name">民族</div>
                <div class="line-cell-value"><el-input v-model="cardVerifyInfo.folk" placeholder="请输入民族"></el-input></div>
              </div>
              <div class="is-pass">
                <i v-if="!checkIsPass(`${userData.nation}族`, cardVerifyInfo.folk)" class="el-icon-close"></i>
                <i v-else class="el-icon-check"></i>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!isView" class="next-button">
          <div class="prev" @click="portraitStep = 2">上一步</div>
          <div v-if="isCanVerify" class="pass">
            <el-button :loading="passLoading" @click="cardVerify">核验通过</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'portrait',
  data () {
    return {
      portraitStep: 1,
      loading: false,
      loaded: false,
      // 摄像头是否开启
      isFilming: false,
      // 身份证与摄像头照片比对结果
      CameraPhotoCompareCode: '0',
      CameraPhotoCompareNum: '',
      userPhotoCompareCode: '0',
      userPhotoCompareNum: 0,
      cardVerifyInfo: {
        trueName: '',
        gender: '',
        birthday: '',
        folk: ''
      },
      // 摄像头照片
      cameraPhotoPath: '',
      passLoading: false,
      isCanVerify: false
    }
  },
  props: {
    userData: {
      type: Object,
      default: () => {}
    },
    studentId: {
      type: String,
      default: ''
    },
    isView: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 替换为采集照片
    replaceUserPhoto () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/student/cardVerify/replaceUserPhoto',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.studentId
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.cardVerifyInfo.userPhotoPath = this.cameraPhotoPath
              this.userPhotoCompareNum = this.CameraPhotoCompareNum
              this.userPhotoCompareCode = this.CameraPhotoCompareCode
              break
            }
            default: {
              this.$message.error(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    getCamera () {
      const that = this
      that.isFilming = true
      if (navigator.mediaDevices) {
        navigator.mediaDevices.enumerateDevices().then((devices) => {
          let cameras = devices.filter(device => device.kind === 'videoinput')
          if (cameras && cameras.length) {
            navigator.mediaDevices
              .getUserMedia({
                video: {
                  deviceId: cameras[0].deviceId,
                  width: 672,
                  height: 810
                }
              })
              .then((stream) => {
                // 摄像头开启成功
                that.$refs.video.srcObject = stream
                that.$refs.video.play()
              })
              .catch(() => {
                that.$message({
                  message: '摄像头开启失败',
                  type: 'error'
                })
                that.isFilming = false
              })
          } else {
            that.$message({
              message: '摄像头开启失败',
              type: 'error'
            })
            that.isFilming = false
          }
        })
      }
    },
    DateFormat (time) {
      if (time) {
        return time.substring(0, 4) + '年' + time.substring(4, 6) + '月' + time.substring(6, 8) + '日'
      } else {
        return ''
      }
    },
    upDateFormat (time) {
      if (time) {
        return time.substring(0, 4) + '-' + time.substring(4, 6) + '-' + time.substring(6, 8)
      } else {
        return ''
      }
    },
    checkIsPass (name, value) {
      return name === value
    },
    checkDateIsPass (date, value) {
      let newDate = value.replace(/-/g, '')
      return newDate === date
    },
    cardVerify () {
      if (this.userPhotoCompareCode !== '1') {
        this.$message.error('身份证与个人照片比对未通过')
        return
      }
      if (this.CameraPhotoCompareCode !== '1') {
        this.$message.error('身份证与摄像头照片比对未通过')
        return
      }
      if (!this.checkIsPass(this.userData.name, this.cardVerifyInfo.trueName)) {
        this.$message.error('姓名核验未通过')
        return
      }
      if (!this.checkIsPass(this.userData.sex, this.cardVerifyInfo.gender)) {
        this.$message.error('性别核验未通过')
        return
      }
      if (!this.checkDateIsPass(this.userData.born, this.cardVerifyInfo.birthday)) {
        console.log(this.userData.born, this.cardVerifyInfo.birthday)
        this.$message.error('出生年月核验未通过')
        return
      }
      if (!this.checkIsPass(`${this.userData.nation}族`, this.cardVerifyInfo.folk)) {
        this.$message.error('民族核验未通过')
        return
      }
      this.passLoading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/student/cardVerify',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.studentId,
          birthday: this.cardVerifyInfo.birthday,
          cardBirthday: this.upDateFormat(this.userData.born),
          cardFolk: this.userData.nation,
          cardGender: this.userData.sex,
          cardNo: this.userData.cardno,
          cardTrueName: this.userData.name,
          folk: this.cardVerifyInfo.folk,
          gender: this.cardVerifyInfo.gender,
          trueName: this.cardVerifyInfo.trueName
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success('核验通过')
              this.$emit('verify-pass')
              break
            }
            default: {
              this.$message.error(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求失败，请稍后重试')
      }).finally(() => {
        this.passLoading = false
      })
    },
    getPhotoBase64 (photobase64) {
      if (photobase64) {
        return `data:image/jpeg;base64,${photobase64}`
      } else {
        return ''
      }
    },
    CloseCamera () {
      if (this.$refs.video && this.$refs.video.srcObject) {
        this.$refs.video.srcObject.getTracks()[0].stop()
      }
      this.isFilming = false
    },
    takePhoto () {
      this.$refs.canvasDom.width = this.$refs.video.videoWidth
      this.$refs.canvasDom.height = this.$refs.video.videoHeight
      this.$refs.canvasDom.getContext('2d').drawImage(this.$refs.video, 0, 0)
      this.cameraPhotoPath = this.$refs.canvasDom.toDataURL('image/png')
      this.cameraPhotoCompare()
    },
    // 人证核验-身份证与摄像头照片比对
    cameraPhotoCompare () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/student/cardVerify/cameraPhotoCompare',
        method: 'post',
        disableErrorPage: true,
        data: this.$qs.stringify({
          cameraPhoto: this.cameraPhotoPath,
          studentId: this.studentId
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              if (!response.data.isPass) {
                this.$message.error('身份证与摄像头照片比对未通过')
                this.CameraPhotoCompareCode = '2'
              } else {
                this.CameraPhotoCompareCode = '1'
              }
              this.CameraPhotoCompareNum = response.data['cameraSimilarity']
              this.isFilming = false
              break
            }
            default: {
              this.cameraPhotoPath = ''
              this.$message.error(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求失败，请稍后重试')
      }).finally(() => {
        this.loaded = true
        this.loading = false
      })
    },
    // 人证核验-身份证与个人照片比对
    userPhotoCompare () {
      const that = this
      this.loading = true
      that.$ajax({
        url: '/workspace/manager/enrolling/student/cardVerify/userPhotoCompare',
        method: 'post',
        disableErrorPage: true,
        data: this.$qs.stringify({
          studentId: that.studentId
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              if (!response.data.isPass) {
                this.userPhotoCompareCode = '2'
                this.userPhotoCompareNum = response.data['similarity']
                break
              } else {
                this.userPhotoCompareCode = '1'
                this.userPhotoCompareNum = response.data['similarity']
                break
              }
            }
            default: {
              this.$message.error(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求失败，请稍后重试')
      }).finally(() => {
        this.loaded = true
        this.loading = false
      })
    },
    // 人工核验通过
    humanFaceVerify () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/student/cardVerify/humanFaceVerify',
        method: 'post',
        disableErrorPage: true,
        data: this.$qs.stringify({
          studentId: this.studentId
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.CameraPhotoCompareCode = '1'
              break
            }
            default: {
              this.$message.error(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求失败，请稍后重试')
      }).finally(() => {
        this.loaded = true
        this.loading = false
      })
    },
    // 获取核验信息
    studentBasicInfo () {
      const that = this
      this.$ajax({
        url: '/workspace/manager/enrolling/student/cardVerify/studentBasicInfo',
        method: 'post',
        data: this.$qs.stringify({
          studentId: that.studentId
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              that.cardVerifyInfo = response.data['cardVerifyInfo']
              that.isCanVerify = that.cardVerifyInfo['isCanVerify']
              // this.userPhotoCompare()
              if (that.cardVerifyInfo.cardPhotoPath) {
                that.cameraPhotoPath = that.cardVerifyInfo.cameraPhotoPath
                that.CameraPhotoCompareNum = that.cardVerifyInfo.cameraSimilarity
                if (!that.cardVerifyInfo.cameraPhotoIsPass) {
                  that.CameraPhotoCompareCode = '2'
                } else {
                  that.CameraPhotoCompareCode = '1'
                }
              }
              break
            }
            default: {
              this.$message.error(response.data['message'])
              this.loading = false
              break
            }
          }
        }
      }, () => {
        this.loading = false
        this.$message.error('请求失败，请稍后重试')
      }).finally(() => {
        this.loaded = true
        this.loading = false
      })
    },
    toStepTwo () {
      if (this.CameraPhotoCompareCode !== '1') {
        this.$message.error('请先通过通过人像采集')
        return
      }
      this.portraitStep = 2
      this.userPhotoCompare()
    },
    toStepThree () {
      if (this.userPhotoCompareCode !== '1' || this.CameraPhotoCompareCode !== '1') {
        this.$message.error('人证核验未通过')
        return
      }
      this.portraitStep = 3
    }
  },
  beforeDestroy () {
    this.CloseCamera()
  },
  mounted () {
    this.loading = true
    this.studentBasicInfo()
  }
}
</script>

<style scoped lang="scss">
.human-verify {
  padding: 18px 20px 19.5px;
  height: 482px;
  .next-button {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding-right: 20px;
    & > .next {
      cursor: pointer;
      width: 160px;
      height: 42px;
      line-height: 42px;
      text-align: center;
      background-color: #0D59A7;
      color: #FFFFFF;
      font-size: 16px;
      border-radius: 8px;
    }
    & > .prev {
      cursor: pointer;
      width: 160px;
      height: 42px;
      line-height: 42px;
      text-align: center;
      border: 1px solid rgb(13, 89, 167);
      background-color: #fff;
      color: #0D59A7;
      font-size: 16px;
      border-radius: 8px;
      margin-right: 14px;
    }
    & > .pass {
      .el-button {
        width: 160px;
        height: 42px;
        background-color: #0D59A7;
        color: #fff;
        border-radius: 8px;
        border: none;
        font-size: 16px;
      }
    }
  }
  & > .verify-steps {
    height: 32px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    & > .step {
      display: flex;
      align-items: center;
      height: 32px;
      margin-left: 6px;
      &::after {
        content: '';
        display: inline-block;
        width: 160px;
        height: 1px;
        background-color: #0D59A7;
        left: 0;
        top: 16px;
      }
      &:last-child {
        &::after {
          display: none;
        }
      }
      & > .step-num {
        width: 32px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        border-radius: 50%;
        background-color: #EEEEEE;
        font-size: 14px;
        color: #999999;
        margin-right: 8px;
      }
      & > .active {
        color: #fff;
        background-color: #0D59A7;
      }
      & > .step-name {
        font-size: 16px;
        color: #333333;
        margin-right: 8px;
      }
    }
  }
  & > .left-camera {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    & > .camera-top {
      width: 100%;
    }
    & > .replace {
      text-align: right;
      text-decoration: underline;
      color: #027DB4;
      margin: 2px 0;
      font-size: 12px;
      cursor: pointer;
    }
    & > .camera-content {
      //margin-top: 10px;
      width: 224px;
      background-color: #ECF4FF;
      background-image: url("../../../../../../assets/icons/camera_bg.png");
      background-position: center;
      background-repeat: no-repeat;
      height: 270px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 12px;
      overflow: hidden;
      & > .camera-bg {
        width: 220px;
        height: 320px;
        margin: 0 auto;
        & > .camera {
          width: 100%;
          height: 100%;
        }
      }
      & > .camera-img {
        width: 196px;
        height: 250px;
        border: 1px solid #f0f0fb;
        margin: 0 auto;
        position: relative;
        & > .judge {
          position: absolute;
          bottom: 70px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 24px;
          border-radius: 50%;
          text-align: center;
          width: 34px;
          height: 34px;
          color: white;
          line-height: 34px;
        }
        & > .num {
          position: absolute;
          bottom: 42px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 14px;
          color: #fff;
        }
        & > .red {
          background-color: #F44B4B;
        }
        & > .green {
          background-color: #42DA4A;
        }
        & > img {
          width: 100%;
          height: 100%;
          border-radius: 8px;
          object-fit: cover;
        }
      }
    }
    & > .photo-group {
      margin-top: 10px;
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: center;
      padding: 0 40px;
      & > .take-photo {
        width: 120px;
        height: 36px;
        line-height: 36px;
        border-radius: 8px;
        background-color: #fff;
        color: #0D59A7;
        font-size: 14px;
        cursor: pointer;
        text-align: center;
        border: 1px solid rgb(13, 89, 167);
        margin-right: 34px;
        &:last-child {
          margin-right: 0;
        }
      }
      & > .left {
        margin-left: 10px;
      }
    }
  }
  & > .right-info {
    display: flex;
    flex-direction: column;
    align-items: normal;
    justify-content: flex-start;
    border-radius: 5px;
    margin-top: 49px;
    & > .top-diff {
      width: 780px;
      height: 250px;
      background-color: #ECF4FF;
      margin: 0 auto 67px;
      border-radius: 8px;
      & > .diff-content {
        //margin-top: 10px;
        height: 100%;
        padding: 15px 40px 5px;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        align-items: center;
        & > .judge-outer {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 53px;
          & > .judge {
            font-size: 24px;
            border-radius: 50%;
            text-align: center;
            width: 34px;
            height: 34px;
            color: white;
            line-height: 34px;
          }
          & > .red {
            background-color: #F44B4B;
          }
          & > .green {
            background-color: #42DA4A;
          }
          & > .num {
            margin-top: 10px;
            font-size: 16px;
            font-weight: 550;
            color: #333333;
            width: 100%;
            text-align: center;
          }
        }
        & > .id-img {
          float: left;
          text-align: center;
          color: #666666;
          font-size: 14px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          & > img {
            width: 140px;
            height: 180px;
            object-fit: cover;
            border-radius: 8px;
          }
          & > .img-name {
            color: #666666;
            margin-top: 8px;
          }
        }
        & > .self-img {
          float: right;
          text-align: center;
          color: #666666;
          font-size: 14px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          position: relative;
          & > img {
            width: 140px;
            height: 180px;
            object-fit: cover;
            border-radius: 8px;
          }
          & > .img-name {
            margin-top: 8px;
          }
          & > .replace {
            position: absolute;
            bottom: -14px;
            color: #0D59A6;
            text-decoration: underline;
            font-size: 12px;
            left: 26px;
            cursor: pointer;
          }
        }
      }
    }
  }
  & > .three-step {
    margin-top: 98px;
    & > .bottom-check {
      & > .check-content {
        margin-top: 10px;
        border-radius: 6px;
        padding: 6px 0 1px;
        overflow: hidden;
        display: flex;
        justify-content: center;
        margin-bottom: 99px;
        & > .basic-info {
          border-radius: 12px;
          width: 210px;
          flex-shrink: 0;
          padding: 0 10px;
          border: 1px solid rgb(238, 238, 238);
          display: flex;
          flex-direction: column;
          & > .line {
            height: 40px;
            border-bottom: 1px solid #EEEEEE;
            display: flex;
            align-items: center;
            font-size: 14px;
            &:last-child {
              border-bottom: none;
            }
            & > .line-name {
              color: #666666;
              width: 76px;
            }
            & > .line-value {
              color: #333333;
            }
          }
        }
        & > .write-info {
          & > .line {
            display: flex;
            padding: 3px 30px;
            height: 41px;
            & > .line-cell {
              display: flex;
              align-items: center;
              & > .line-cell-name {
                font-size: 14px;
                width: 70px;
                flex-shrink: 0;
                font-weight: 550;
                color: #666666;
              }
              & > .line-cell-value {
                color: #333333;
                font-size: 14px;
                & > .el-input {
                  width: 180px;
                  height: 30px;
                  & > .el-input__inner {
                    height: 30px;
                    border-radius: 8px;
                    border: 1px solid #EEEEEE;
                    background-color: #fff;
                    color: #333333;
                  }
                }
                & > .el-date-picker {
                  width: 100%;
                  height: 30px;
                  & > .el-input__inner {
                    height: 30px;
                    border-radius: 5px;
                    border: 1px solid #f0f0fb;
                    background-color: #fff;
                  }
                }
              }
            }
            & > .is-pass {
              display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 10px;
              & > .el-icon-check {
                color: #42DA4A;
                font-size: 18px;
              }
              & > .el-icon-close {
                color: #F44B4B;
                font-size: 18px;
              }
            }
          }
        }
      }
      & > .pass {
        width: 100%;
        display: flex;
        justify-content: center;
        & > .el-button {
          margin-top: 8px;
          background: #0D59A6;
          color: white;
          padding: 8px 30px;
          border-radius: 5px;
        }
      }
    }
  }
}
</style>
